import { Component, ViewChild, ElementRef, Input, OnInit, OnChanges, SimpleChanges, Renderer2, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { EventEmitter } from '@angular/core';
import { retry } from 'rxjs/operators';
import { SearchFilter, IFilterComponent } from '../../../infrastructure/iFilter-component';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { PatientSearch } from '../../../model/patient/patient-search';
import { switchMap, map, filter, debounceTime, tap, switchAll, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PatientService } from '../../../services/patient.service';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  selector: 'app-search-complete-filter-component',
  host: { '(document:click)': 'handleClick($event)' },
  templateUrl: './search-complete-filter.component.html',
  styleUrls: ['./search-complete-filter.component.css']
})

export class SearchCompleteFilterComponent implements OnInit, OnChanges {

  form: FormGroup;
  loading = false;
  widthExp = 800;
  completingFilter: boolean;
  completingFilterClick: boolean;
  @ViewChild('entity', {static: false}) entity: ElementRef;
  @Input() filter: IFilterComponent;
  @Output() endSearch = new EventEmitter();
  @Output() startSearch = new EventEmitter();
  @Output() keyup = new EventEmitter();
  patients: PatientSearch[] = [];

  constructor(private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , private renderer: Renderer2
    , private patientService: PatientService
    , private deviceService: DeviceDetectorService) {
    this.form = this.formBuilder.group({
      PatientCtrl: [null]
    });
  }

  async ngOnInit() {
    if (this.filter.setFilters()) {
      await this.search();
    }

    this.f.PatientCtrl.valueChanges.pipe(
      filter(value => {
        if (value != null && value !== '' && typeof value === 'string') {
          return true;
        } else {
          if (value == null || value === '') {
            this.patients = [];
          }
          return false;
        }
      }),
      debounceTime(300),
      tap(() => this.loading = true),
      switchMap(value => this.patientService.getPatientsFromSearch(value)
        .pipe(finalize(() => this.loading = false), ))
    ).subscribe(values => this.patients = values);
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.filter && this.filter.formElement) {
      this.entity.nativeElement.appendChild(this.filter.formElement.nativeElement);
    }
    // if (this.deviceService.browser != "chrome" ) {
    //  this.widthExp = 300;
    // }
  }

  openCompleteFilter(): void {
    this.completingFilter = true;
    this.completingFilterClick = true;
  }

  completeFilter(): void {
    this.completingFilter = !this.completingFilter;
    this.completingFilterClick = true;
  }

  handleClick(event) {
    if (this.completingFilter && !this.completingFilterClick) {
      let clickedComponent = event.target;
      let inside = false;
      do {
        if (clickedComponent
          && clickedComponent.classList
          && (clickedComponent.classList.contains('cdk-overlay-backdrop')
            || clickedComponent.classList.contains('filter-container')
            || clickedComponent.classList.contains('mat-option-text')
            || clickedComponent.classList.contains('ng-trigger'))) {
          inside = true;
        }
        clickedComponent = clickedComponent.parentNode;
      } while (clickedComponent && !inside);

      if (!inside) {
        this.completingFilter = inside;
      }
    }
    this.completingFilterClick = false;
  }

  onKeyup(event: any) {
    this.completingFilter = false;
    this.keyup.emit(event);
  }

  displayFn(item?: PatientSearch): string | undefined {
    return item ? item.LastName + ', ' + item.FirstName : undefined;
  }

  get f() { return this.form.controls; }

  private getSearchFilters(): SearchFilter[] {
    const filters = this.filter.getSearchFilters();
    filters.forEach((filter) => {
      filter.onRemove.on((searchFilter) => {
        this.filter.form.get(searchFilter.key).setValue(null);
        this.search();
      });
    });

    return filters;
  }

  async search() {
    let items: any;
    try {
      this.completingFilter = false;
      this.loading = true;
      this.startSearch.emit();
      this.filter.saveFilters();
      items = await this.filter.search();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Búsqueda');
    } finally {
      this.endSearch.emit({
        items: items,
        searchFilters: this.getSearchFilters()
      });
      this.loading = false;
    }
  }
}
